const { Serializer } = require("jsonapi-serializer");

module.exports = {
  setDocumentActiveSerializer: (meta = {}) =>
    new Serializer("setDocumentActiveSerializer", {
      meta,
      pluralizeType: false,
      keyForAttribute: "snake_case",
      attributes: [
        "document_id",
        "active",
        "user_email",
        "user_ip"
      ]
    })
};
